// extracted by mini-css-extract-plugin
export default {"topicBlock":"TopicBlock_topicBlock__JnA-B","text":"TopicBlock_text__kKcXd","actions":"TopicBlock_actions__8cUaS","action":"TopicBlock_action__ztD+d"};